

exports.__esModule = true;
exports.$xoSidebarAddCardPageComponent = undefined;

var _template = require('./template');

var _template2 = _interopRequireDefault(_template);

require('components/xo-wallet-components/src/add-card/directive');

require('components/xo-page-components/src/aside-header/directive');

require('components/xo-validation/dist/directive');

require('components/xo-ui-components/src/tooltip/directive');

require('components/xo-ui-components/src/dropdown/directive');

var _squid = require('squid');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var $xoSidebarAddCardPageComponent = exports.$xoSidebarAddCardPageComponent = _squid.$Component.extend('$xoSidebarAddCardPageComponent', {
    tag: 'xo-sidebar-add-card-page',
    template: _template2['default'],

    scope: {
        promotion: '='
    },

    controller: function controller($scope, $rootScope, $state) {
        // eslint-disable-line no-shadow
        $scope.billingaddressupdated = {
            value: false
        };
        $scope.sidebar = true;
        $scope.token = $rootScope.token;
        $scope.message = {};
        $scope.callbacks = {
            finish: function finish() {
                $state.go('checkout.review');
            }
        };
    }
});

angular.value("$xoSidebarAddCardPageComponent", $xoSidebarAddCardPageComponent);
_squid.$Component;


/*****************
 ** WEBPACK FOOTER
 ** ./pages/xo-sidebar-add-card/directive.js
 ** module id = 331
 ** module chunks = 1
 **/